var map = {
	"./12_purple.mp3": "60d1",
	"./14_orange.mp3": "7ab3",
	"./17_calm.mp3": "70c2",
	"./18_angry.mp3": "eb58",
	"./24_sister.mp3": "cf19",
	"./27_grandma.mp3": "e199",
	"./32_robot.mp3": "bd41",
	"./35_three.mp3": "56fe",
	"./36_sing.mp3": "3203",
	"./41_paint.mp3": "965f",
	"./46_lemon.mp3": "c968",
	"./49_tomato.mp3": "d736",
	"./51_cat.mp3": "6c6d",
	"./56_canary.mp3": "b204",
	"./59_head.mp3": "ff53",
	"./5_rabbit.mp3": "7b3f",
	"./63_pat.mp3": "4a07",
	"./66_dress.mp3": "e306",
	"./68_jacket.mp3": "e98d",
	"./7_mole.mp3": "bace",
	"./M_Brilliant.mp3": "ca55",
	"./M_Excellent.mp3": "289e",
	"./M_Fantastic.mp3": "106c",
	"./M_Great.mp3": "fd9c",
	"./M_Perfect.mp3": "c7d9",
	"./M_Think again.mp3": "04ec",
	"./M_Try again.mp3": "9971",
	"./M_Very good.mp3": "9699",
	"./M_Well done.mp3": "53fc",
	"./M_Work harder.mp3": "de22",
	"./click.mp3": "1ff3",
	"./false.mp3": "d79b",
	"./true.mp3": "8e6c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "851f";